import React from 'react';
import TopBar from "../components/TopBar";
import Footer from "../components/Footer";
import "../App.css";
import ContactForm from '../components/ContactForm';

function AboutUs() {
  return (
    <div className="App">
      <TopBar />
      <div className="App-header-services" style={{ padding: '8vw 8px 8px 8px', marginBottom: '10vh' }}>
        <div className="about-us-text" style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
          <h1 className="hero-title">About Us</h1>
          <p className="hero-subtitle" style={{ fontSize: '1.2rem', color: '#333', marginBottom: '32px' }}>
With Approx. 10 Years experience working with senior living, we understand the caregiver's burden and truly believe that caring for others is more than just a service it's a calling— At Connection Health Care (CHC) our mission is to provide compassionate, reliable, and personalized care that supports the dignity, comfort, and well-being of every individual we serve more important is to relief the caregivers and to keep the families up the the same living style not to change because of your love one needs extra cares. Our diverse team of Personal Support Workers (PSWs) and Home Caregivers brings together professionals with backgrounds in nursing, home care, housekeeping and specialized support services. This blend of skills and compassion allows us to meet a wide range of needs — from daily living assistance to complex care requirements. At CHC, we treat every client like family. We take the time to understand each person’s story, preferences, and goals, so that our care enhances both quality of life and peace of mind for families. With professionalism, compassion, and respect at the heart of everything we do, CHC is here to make every day safer, brighter, and more meaningful for those you love most and provide the relief you deserve.          </p>
          <div style={{ margin: '40px auto', maxWidth: '800px', width: '100%' }}>
            <img 
              src="/caring8.jpg"
              alt="Connection Health Care Team" 
              style={{ 
                width: '100%', 
                height: 'auto', 
                borderRadius: '12px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
              }} 
            />
          </div>          
          <p style={{ fontSize: '1rem', color: '#555' }}>
“Whatever you do, work at it with all your heart, as working for the Lord, not for human masters.”
— Colossians 3:23          
          </p>
        </div>
      </div>
      <ContactForm />
      <Footer />
    </div>
  );
}

export default AboutUs;